/**
 * Whitelist of stablecoin / native token mint addresses per chain.
 * Pools must contain at least one of these tokens to be considered valid
 * for CEX-DEX or DEX-DEX spread calculations.
 */
export const ALLOWED_QUOTE_MINTS: Record<string, Set<string>> = {
  sol: new Set([
    'so11111111111111111111111111111111111111112', // SOL
    'epjfwdd5aufqssqem2qn1xzybapc8g4weggkzwytdt1v', // USDC
    'es9vmfrzacermjfrf4h2fyd4kconky11mcce8benwnyb', // USDT
  ]),
  bsc: new Set([
    '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', // WBNB
    '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d', // USDC
    '0x55d398326f99059ff775485246999027b3197955', // USDT
  ]),
  eth: new Set([
    '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', // WETH
    '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', // USDC
    '0xdac17f958d2ee523a2206206994597c13d831ec7', // USDT
  ]),
  base: new Set([
    '0x4200000000000000000000000000000000000006', // WETH
    '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913', // USDC
    '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2', // USDT
  ]),
  monad: new Set([
    '0x42cfab6eb59d5bbb75cabc7e2213a8dffb1a2d2b', // native
    '0x754704bc059f8c67012fed69bc8a327a5aafb603', // USDC
    '0x0000000000000000000000000000000000000000', // USDT
  ]),
}

/**
 * Canonical token symbols by lowercase contract / mint address.
 * Used to normalize DexScreener's per-pool symbol metadata which can be
 * inconsistent for the same address across different DEXs.
 */
export const TOKEN_SYMBOLS: Record<string, string> = {
  // Solana
  'so11111111111111111111111111111111111111112': 'SOL',
  'epjfwdd5aufqssqem2qn1xzybapc8g4weggkzwytdt1v': 'USDC',
  'es9vmfrzacermjfrf4h2fyd4kconky11mcce8benwnyb': 'USDT',

  // BSC
  '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c': 'WBNB',
  '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d': 'USDC',
  '0x55d398326f99059ff775485246999027b3197955': 'USDT',

  // ETH
  '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2': 'WETH',
  '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48': 'USDC',
  '0xdac17f958d2ee523a2206206994597c13d831ec7': 'USDT',

  // Base
  '0x4200000000000000000000000000000000000006': 'WETH',
  '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913': 'USDC',
  '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2': 'USDT',

  // Monad
  '0x42cfab6eb59d5bbb75cabc7e2213a8dffb1a2d2b': 'MONAD',
  '0x754704bc059f8c67012fed69bc8a327a5aafb603': 'USDC',
  '0x0000000000000000000000000000000000000000': 'USDT',
}
